export const PAYWALL_TYPE = {
  WEBVIEW: 'WebView',
  NATIVE: 'Native',
  STRIPE_CHECKOUT: 'Stripe Checkout',
};

// Which paywall design the user was shown. Only the webview paywall sets this
// today — it is the split for the auraDesignChange experiment (PROD-5084), and
// without it the two arms are indistinguishable in Mixpanel.
export const PAYWALL_DESIGN = {
  LEGACY: 'Legacy',
  AURA_4: 'Aura 4.0',
};

export function getPaywallAnalyticsProperties({
  redirectedFromApp = false,
  paywallType,
  design,
} = {}) {
  const resolvedPaywallType =
    paywallType ||
    (redirectedFromApp ? PAYWALL_TYPE.WEBVIEW : PAYWALL_TYPE.STRIPE_CHECKOUT);
  return {
    'Paywall Type': resolvedPaywallType,
    'Redirected From App': !!redirectedFromApp,
    // Omitted entirely on surfaces that don't run the design experiment, so
    // their event shape is unchanged.
    ...(design ? { 'Paywall Design': design } : {}),
  };
}
